import React from 'react';

export default function MapComponent() {
  return (
    <div className="stat item-box-shadow h-100">
      <div className="w-100">
        <h4 className="cms-text-primary font-weight-bold pl-2 mb-4">
          Map
        </h4>
      </div>
      <div className="mapouter">
        <div className="gmap_canvas">
          <iframe
            title="googlemap"
            width="100%"
            height="400"
            id="gmap_canvas"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30888.36334707406!2d120.96204765870584!3d14.596487859627391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397ca03571ec38b%3A0x69d1d5751069c11f!2sManila%2C%20Metro%20Manila!5e0!3m2!1sen!2sph!4v1581053425782!5m2!1sen!2sph"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            style={{
              border: 0,
            }}
          />
        </div>
      </div>
    </div>
  );
}
